// extracted by mini-css-extract-plugin
export default {"number":"CountUp_number__33JCI"};